import type { SVGProps } from "react";
export default function SvgDocumentAnalysisApp(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 178 188"
			{...props}
		>
			<foreignObject width={141.949} height={192} x={0} y={-4}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1091_1316_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_ddddi_1091_1316)">
				<path
					fill="url(#paint0_linear_1091_1316)"
					fillOpacity={0.6}
					d="M96.674 14H45.275C42.362 14 40 16.352 40 19.254v73.492C40 95.648 42.362 98 45.275 98h51.399c2.913 0 5.275-2.352 5.275-5.254V19.254c0-2.902-2.362-5.254-5.275-5.254"
				/>
				<path
					stroke="url(#paint1_linear_1091_1316)"
					d="M45.275 14.5h51.399c2.639 0 4.775 2.13 4.775 4.754v73.492c0 2.624-2.136 4.754-4.775 4.754H45.275c-2.639 0-4.775-2.13-4.775-4.754V19.254c0-2.624 2.136-4.754 4.775-4.754Z"
				/>
			</g>
			<path
				fill="#FAFF00"
				d="M88.683 40.507H53.228a2.235 2.235 0 0 1-2.24-2.232 2.235 2.235 0 0 1 2.24-2.231h35.455c1.238 0 2.24.998 2.24 2.231a2.235 2.235 0 0 1-2.24 2.232"
			/>
			<path
				fill="#FAFF00"
				d="M88.683 54.422H53.228a2.235 2.235 0 0 1-2.24-2.232 2.235 2.235 0 0 1 2.24-2.231h35.455c1.238 0 2.24.998 2.24 2.231a2.235 2.235 0 0 1-2.24 2.232"
			/>
			<path
				fill="#FAFF00"
				d="M71.828 68.338h-18.6a2.235 2.235 0 0 1-2.24-2.232 2.235 2.235 0 0 1 2.24-2.231h18.6c1.238 0 2.24.999 2.24 2.231a2.235 2.235 0 0 1-2.24 2.232"
			/>
			<foreignObject width={145.517} height={173.521} x={31.6367} y={10.8037}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_1_1091_1316_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter1_ddddi_1091_1316)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="M135.979 87.504 119.246 70.77a25.6 25.6 0 0 0 3.116-5.513 26.2 26.2 0 0 0 1.998-9.445v-.64c0-3.468-.671-6.888-1.998-10.1a26.2 26.2 0 0 0-5.721-8.55 26.4 26.4 0 0 0-8.55-5.722 26.7 26.7 0 0 0-9.445-1.997h-.64c-3.468 0-6.904.67-10.1 1.997a26.4 26.4 0 0 0-8.55 5.722 26.4 26.4 0 0 0-5.722 8.55 26.4 26.4 0 0 0-1.997 10.1v.64c.08 3.244.767 6.456 1.997 9.445a26.4 26.4 0 0 0 5.722 8.55 26.2 26.2 0 0 0 8.55 5.721 26.289 26.289 0 0 0 20.185 0 26.3 26.3 0 0 0 5.513-3.1l16.733 16.732a3.994 3.994 0 1 0 5.642-5.657m-30.941-15.358a18.288 18.288 0 0 1-14.063 0 18.15 18.15 0 0 1-5.962-3.98 18.5 18.5 0 0 1-3.995-5.96 18.8 18.8 0 0 1-1.374-6.138v-.895a18 18 0 0 1 1.374-7.032 18.2 18.2 0 0 1 3.995-5.96 18.27 18.27 0 0 1 12.993-5.386h.895a19.3 19.3 0 0 1 6.137 1.39 18.5 18.5 0 0 1 5.961 3.995 18.1 18.1 0 0 1 3.98 5.961 18 18 0 0 1 1.374 6.121l.032.911c0 2.413-.479 4.795-1.406 7.032a18.5 18.5 0 0 1-3.98 5.961 18.5 18.5 0 0 1-5.961 3.98"
				/>
				<path
					stroke="url(#paint2_linear_1091_1316)"
					strokeOpacity={0.5}
					d="M98.007 29.304h.627l.596.021c2.976.143 5.905.806 8.669 1.938a25.9 25.9 0 0 1 8.388 5.613l.002.002a25.6 25.6 0 0 1 5.36 7.802l.251.585a25.9 25.9 0 0 1 1.96 9.908v.64a25.7 25.7 0 0 1-1.959 9.252l-.001.001a25.2 25.2 0 0 1-3.055 5.407l-.258.346 17.038 17.038a3.493 3.493 0 0 1 0 4.95c-1.354 1.355-3.564 1.357-4.937-.001l-17.034-17.034-.345.254a25.8 25.8 0 0 1-5.41 3.041 25.79 25.79 0 0 1-19.801 0 25.7 25.7 0 0 1-8.387-5.612h-.002a26 26 0 0 1-5.361-7.805l-.251-.584a26.1 26.1 0 0 1-1.939-8.67l-.021-.596v-.627c0-3.403.659-6.757 1.96-9.908a25.93 25.93 0 0 1 14-14.001 25.9 25.9 0 0 1 9.91-1.96Zm18.879 25.86-.001-.009-.031-.91-.001-.006a18.5 18.5 0 0 0-1.414-6.29 18.7 18.7 0 0 0-3.762-5.793l-.325-.33a19 19 0 0 0-6.122-4.102l-.002-.001-.377-.15a19.8 19.8 0 0 0-5.92-1.278h-.924a18.8 18.8 0 0 0-6.795 1.255l-.429.173a18.7 18.7 0 0 0-6.122 4.102 18.7 18.7 0 0 0-3.922 5.697l-.183.428a18.4 18.4 0 0 0-1.41 6.762l-.002.46v.923c.115 2.165.591 4.297 1.412 6.3v.002a19 19 0 0 0 4.102 6.12v.002a18.65 18.65 0 0 0 6.124 4.087v.001a18.8 18.8 0 0 0 14.447 0h.001a19 19 0 0 0 6.124-4.088 19 19 0 0 0 4.086-6.122 18.85 18.85 0 0 0 1.446-7.224z"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_1091_1316"
					x1={71.1325}
					x2={71.1325}
					y1={14}
					y2={98}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1091_1316"
					x1={70.9745}
					x2={34.1231}
					y1={14.9199}
					y2={75.3165}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1091_1316"
					x1={104.395}
					x2={104.395}
					y1={28.8037}
					y2={94.3241}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<clipPath id="bgblur_0_1091_1316_clip_path" transform="translate(0 4)">
					<path d="M96.674 14H45.275C42.362 14 40 16.352 40 19.254v73.492C40 95.648 42.362 98 45.275 98h51.399c2.913 0 5.275-2.352 5.275-5.254V19.254c0-2.902-2.362-5.254-5.275-5.254" />
				</clipPath>
				<clipPath id="bgblur_1_1091_1316_clip_path" transform="translate(-31.637 -10.804)">
					<path d="M135.979 87.504 119.246 70.77a25.6 25.6 0 0 0 3.116-5.513 26.2 26.2 0 0 0 1.998-9.445v-.64c0-3.468-.671-6.888-1.998-10.1a26.2 26.2 0 0 0-5.721-8.55 26.4 26.4 0 0 0-8.55-5.722 26.7 26.7 0 0 0-9.445-1.997h-.64c-3.468 0-6.904.67-10.1 1.997a26.4 26.4 0 0 0-8.55 5.722 26.4 26.4 0 0 0-5.722 8.55 26.4 26.4 0 0 0-1.997 10.1v.64c.08 3.244.767 6.456 1.997 9.445a26.4 26.4 0 0 0 5.722 8.55 26.2 26.2 0 0 0 8.55 5.721 26.289 26.289 0 0 0 20.185 0 26.3 26.3 0 0 0 5.513-3.1l16.733 16.732a3.994 3.994 0 1 0 5.642-5.657m-30.941-15.358a18.288 18.288 0 0 1-14.063 0 18.15 18.15 0 0 1-5.962-3.98 18.5 18.5 0 0 1-3.995-5.96 18.8 18.8 0 0 1-1.374-6.138v-.895a18 18 0 0 1 1.374-7.032 18.2 18.2 0 0 1 3.995-5.96 18.27 18.27 0 0 1 12.993-5.386h.895a19.3 19.3 0 0 1 6.137 1.39 18.5 18.5 0 0 1 5.961 3.995 18.1 18.1 0 0 1 3.98 5.961 18 18 0 0 1 1.374 6.121l.032.911c0 2.413-.479 4.795-1.406 7.032a18.5 18.5 0 0 1-3.98 5.961 18.5 18.5 0 0 1-5.961 3.98" />
				</clipPath>
				<filter
					id="filter0_ddddi_1091_1316"
					width={141.949}
					height={192}
					x={0}
					y={-4}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1091_1316" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1091_1316"
						result="effect2_dropShadow_1091_1316"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1091_1316"
						result="effect3_dropShadow_1091_1316"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1091_1316"
						result="effect4_dropShadow_1091_1316"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1091_1316" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1091_1316" />
				</filter>
				<filter
					id="filter1_ddddi_1091_1316"
					width={145.517}
					height={173.521}
					x={31.6367}
					y={10.8037}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1091_1316" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1091_1316"
						result="effect2_dropShadow_1091_1316"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1091_1316"
						result="effect3_dropShadow_1091_1316"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1091_1316"
						result="effect4_dropShadow_1091_1316"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1091_1316" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1091_1316" />
				</filter>
			</defs>
		</svg>
	);
}
